import { DEAL_ROOM_COLLEAGUE_ROLE } from 'models/DealRoom';

export const NZ_GST = 15;
export const AU_GST = 10;

export const COLLEAGUES_INITIAL_VALUE = {
  useMessaging: true,
  dataRoomAdmin: true,
  sendNotifications: true,
  role: DEAL_ROOM_COLLEAGUE_ROLE.LEAD_BROKER,
};

export const MONEY_PROPS = [
  'amount',
  'amountFrom',
  'amountTo',
  'averageStockValue',
  'totalPackage',
  'projectedSalePrice',
  'successFeeShare',
];
